<template>
<td>
  <div class="statistic-container">
    <strong class="statistic-name">{{name}}</strong>
    <div class="statistics-separator"></div>
    <span class="statistic-value">{{value}}</span>
  </div>
</td>
</template>

<script>
export default {
  props: ['name', 'value']
}
</script>

<style lang="scss">
.statistic-container {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;

  .statistics-separator {
    flex: 1 1;
    align-self: center;
    border-bottom: 1px dotted rgba(0, 0, 0, 0.2);
    margin: 0 0.3em;
    box-sizing: border-box;
  }

  .statistic-value {
    font-size: 0.9em;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/statistics-cell.vue